import styled from "styled-components"
import { Button, Input, Tabs, TabsContent, TabsList, TabsTrigger, toast, Toaster } from "../../../ui/ot"
import { Row, Col } from "../../../ui/RowCol"
import { Textarea } from "../../../ui/textarea"

import { useTranslation } from "react-i18next"
import { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useBib } from "../../controllers/BibController";

const MARCFormItems = ({
    // mode = "authority",
    // propsOnFinish = () => { },
    // propsMarcjson,
    name = "",
    defaultValue,
    value,
    onValueChange = () => { },
    onChange = () => { }

}) => {
    const { t } = useTranslation('translation');
    const i18nPrefix = "library.addmarc."
    // const [searchParams, setSearchParams] = useSearchParams();
    // const bib_biblionumber = searchParams.get('bib_biblionumber');
    // const location = useLocation()
    // const navigate = useNavigate()
    // const { marcjson } = location.state || { marcjson: undefined }
    const [datas, setDatas] = useState(
        [
            {
                "id": "000",
                "name": "LEADER",
                "children": [
                    {
                        "id": "00",
                        "key": "fixed length control field",
                        "value": "",
                        "require": "true"
                    }
                ]
            },
            {
                "id": "001",
                "name": "CONTROL NUMBER",
                "children": [
                    {
                        "id": "00",
                        "key": "control field",
                        "value": "",
                    }
                ]
            },
            {
                "id": "003",
                "name": "CONTROL NUMBER IDENTIFIER",
                "children": [
                    {
                        "id": "00",
                        "key": "control field",
                        "value": "",
                        "require": "true"
                    }
                ]
            },
            {
                "id": "005",
                "name": "DATE AND TIME OF LATEST TRANSACTION",
                "children": [
                    {
                        "id": "00",
                        "key": "control field",
                        "value": "",
                        "require": "true"
                    }
                ]
            },
            {
                "id": "006",
                "name": "FIXED-LENGTH DATA ELEMENTS--ADDITIONAL MATERIAL CHARACTERISTICS",
                "copy": "true",
                "children": [
                    {
                        "id": "00",
                        "key": "control field",
                        "value": "",
                        "require": "true"
                    }
                ]
            },
            {
                "id": "007",
                "name": "PHYSICAL DESCRIPTION FIXED FIELD--GENERAL INFORMATION",
                "copy": "true",
                "children": [
                    {
                        "id": "00",
                        "key": "fixed length control field",
                        "value": "",
                    }
                ]
            },
            {
                "id": "008",
                "name": "FIXED-LENGTH DATA ELEMENTS--GENERAL INFORMATION",
                "children": [
                    {
                        "id": "00",
                        "key": "fixed length control field",
                        "value": "",
                        "require": "true"
                    }
                ]
            },
            {
                "id": "009",
                "name": "PHYSICAL DESCRIPTION FIXED-FIELD FOR ARCHIVAL COLLECTION (VM) [OBSOLETE]",
                "copy": "true",
                "children": [
                    {
                        "id": "00",
                        "key": "fixed length control field",
                        "value": "",
                    }
                ]
            },
            {
                "id": "009",
                "name": "PHYSICAL DESCRIPTION FIXED-FIELD FOR ARCHIVAL COLLECTION (VM) [OBSOLETE]",
                "copy": "true",
                "children": [
                    {
                        "id": "OC",
                        "key": "fixed length control field",
                        "value": "",
                    }
                ]
            },
            {
                "id": "010",
                "name": "LIBRARY OF CONGRESS CONTROL NUMBER",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "LC control number",
                        "value": "",
                    }
                ]
            },
            {
                "id": "015",
                "name": "NATIONAL BIBLIOGRAPHY NUMBER",
                "copy": "true",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "2",
                        "key": "Source",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "National bibliography number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "q",
                        "key": "Qualifying information",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "016",
                "name": "NATIONAL BIBLIOGRAPHIC AGENCY CONTROL NUMBER",
                "copy": "true",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "2",
                        "key": "Source",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Record control number",
                        "value": "",
                    }
                ]
            },
            {
                "id": "020",
                "name": "INTERNATIONAL STANDARD BOOK NUMBER",
                "copy": "true",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "International Standard Book Number",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Terms of availability",
                        "value": "",
                    },
                    {
                        "id": "q",
                        "key": "Qualifying information",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "022",
                "name": "INTERNATIONAL STANDARD SERIAL NUMBER",
                "copy": "true",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "2",
                        "key": "Source",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "International Standard Serial Number",
                        "value": "",
                    }
                ]
            },
            {
                "id": "024",
                "name": "OTHER STANDARD IDENTIFIER",
                "copy": "true",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "2",
                        "key": "Source of number or code",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Standard number or code",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Terms of availability",
                        "value": "",
                    },
                    {
                        "id": "d",
                        "key": "Additional codes following the standard number or code",
                        "value": "",
                    },
                    {
                        "id": "q",
                        "key": "Qualifying information",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "027",
                "name": "STANDARD TECHNICAL REPORT NUMBER",
                "copy": "true",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Standard technical report number",
                        "value": "",
                    },
                    {
                        "id": "q",
                        "key": "Qualifying information",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Canceled/invalid number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "028",
                "name": "PUBLISHER OR DISTRIBUTOR NUMBER",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "b",
                        "key": "Source",
                        "value": "",
                    }
                ]
            },
            {
                "id": "035",
                "name": "SYSTEM CONTROL NUMBER",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "System control number",
                        "value": "",
                    }
                ]
            },
            {
                "id": "037",
                "name": "SOURCE OF ACQUISITION",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Stock number",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Source of stock number/acquisition",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Terms of availability",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "f",
                        "key": "Form of issue",
                        "value": "",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "g",
                        "key": "Additional format characteristics",
                        "value": "",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "n",
                        "key": "Additional format characteristics",
                        "value": "",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },
            {
                "id": "040",
                "name": "CATALOGING SOURCE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Original cataloging agency",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Language of cataloging",
                        "value": "",
                    },
                    {
                        "id": "e",
                        "key": "Description conventions",
                        "value": "",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "c",
                        "key": "Transcribing agency",
                        "value": "",
                        "require": "true",
                    },
                    {
                        "id": "d",
                        "key": "Modifying agency",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "041",
                "name": "LANGUAGE CODE",
                "copy": "true",
                "indicator": {
                    0: '0',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Language code of text/sound track or separate title",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "044",
                "name": "COUNTRY OF PUBLISHING/PRODUCING ENTITY CODE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "MARC country code",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "045",
                "name": "TIME PERIOD OF CONTENT",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Time period code",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "b",
                        "key": "Formatted 9999 B.C. through C.E. time period",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "047",
                "name": "FORM OF MUSICAL COMPOSITION CODE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of code",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Form of musical composition code",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "048",
                "name": "NUMBER OF MUSICAL INSTRUMENTS OR VOICES CODE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of code",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Performer or ensemble",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "a",
                        "key": "Performer or ensemble",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "a",
                        "key": "Performer or ensemble",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "a",
                        "key": "Performer or ensemble",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "a",
                        "key": "Performer or ensemble",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "b",
                        "key": "Soloist",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "050",
                "name": "LIBRARY OF CONGRESS CALL NUMBER",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Classification number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "b",
                        "key": "Item number",
                        "value": "",
                    }
                ]
            },
            {
                "id": "074",
                "name": "GPO ITEM NUMBER",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "GPO item number",
                        "value": "",
                    },
                    {
                        "id": "z",
                        "key": "Canceled/invalid GPO item number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "082",
                "name": "DEWEY DECIMAL CLASSIFICATION NUMBER",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Edition information",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Classification number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "b",
                        "key": "Item number",
                        "value": "",
                    }
                ]
            },
            {
                "id": "086",
                "name": "GOVERNMENT DOCUMENT CLASSIFICATION NUMBER",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Number source",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Classification number",
                        "value": "",
                    },
                    {
                        "id": "z",
                        "key": "Canceled/invalid classification number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "100",
                "name": "MAIN ENTRY--PERSONAL NAME",
                "indicator": {
                    0: '1',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Personal name",
                        "value": "",
                    },
                    {
                        "id": "e",
                        "key": "Relator term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "d",
                        "key": "Dates associated with a name",
                        "value": "",
                    },
                    {
                        "id": "q",
                        "key": "Fuller form of name",
                        "value": "",
                    }
                ]
            },
            {
                "id": "110",
                "name": "MAIN ENTRY--CORPORATE NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Corporate name or jurisdiction name as entry element",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Subordinate unit",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "e",
                        "key": "Relator term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "111",
                "name": "MAIN ENTRY--MEETING NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Meeting name or jurisdiction name as entry element",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Location of meeting",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "e",
                        "key": "Subordinate unit",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "j",
                        "key": "Relator term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "130",
                "name": "MAIN ENTRY--UNIFORM TITLE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "9",
                        "key": "9 (RLIN)",
                        "value": "",
                        "disabled": "true"
                    },
                    {
                        "id": "a",
                        "key": "Uniform title",
                        "value": "",
                    },
                    {
                        "id": "l",
                        "key": "Language of a work",
                        "value": "",
                    },
                    {
                        "id": "r",
                        "key": "Key for music",
                        "value": "",
                    }
                ]
            },
            {
                "id": "210",
                "name": "ABBREVIATED TITLE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "a",
                        "key": "Abbreviated title",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Qualifying information",
                        "value": "",
                    }
                ]
            },
            {
                "id": "222",
                "name": "KEY TITLE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Key title",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Qualifying information",
                        "value": "",
                    }
                ]
            },
            {
                "id": "240",
                "name": "UNIFORM TITLE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Uniform title",
                        "value": "",
                    },
                    {
                        "id": "h",
                        "key": "Medium",
                        "value": "",
                    },
                    {
                        "id": "l",
                        "key": "Language of a work",
                        "value": "",
                    },
                    {
                        "id": "r",
                        "key": "Key for music",
                        "value": "",
                    },
                    {
                        "id": "s",
                        "key": "Version",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "243",
                "name": "COLLECTIVE UNIFORM TITLE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Uniform title",
                        "value": "",
                    },
                    {
                        "id": "h",
                        "key": "Medium",
                        "value": "",
                    },
                    {
                        "id": "l",
                        "key": "Language of a work",
                        "value": "",
                    },
                    {
                        "id": "s",
                        "key": "Version",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "245",
                "name": "TITLE STATEMENT",
                "indicator": {
                    0: '1',
                    1: '0'
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Title",
                        "value": "",
                        "require": "true"
                    },
                    {
                        "id": "c",
                        "key": "Statement of responsibility, etc.",
                        "value": "",
                    },
                    {
                        "id": "h",
                        "key": "Medium",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Remainder of title",
                        "value": "",
                    },
                    {
                        "id": "n",
                        "key": "Number of part/section of a work",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "p",
                        "key": "Name of part/section of a work",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "246",
                "name": "VARYING FORM OF TITLE",
                "copy": "true",
                "indicator": {
                    0: '1',
                    1: '0'
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Title proper/short title",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Remainder of title",
                        "value": "",
                    },
                    {
                        "id": "h",
                        "key": "Medium",
                        "value": "",
                    },
                    {
                        "id": "i",
                        "key": "Display text",
                        "value": "",
                    }
                ]
            },
            {
                "id": "247",
                "name": "FORMER TITLE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Title",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Remainder of title",
                        "value": "",
                    },
                    {
                        "id": "h",
                        "key": "Medium",
                        "value": "",
                    }
                ]
            },
            {
                "id": "250",
                "name": "EDITION STATEMENT",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Edition statement",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Remainder of edition statement",
                        "value": "",
                    }
                ]
            },
            {
                "id": "260",
                "name": "PUBLICATION, DISTRIBUTION, ETC.",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Place of publication, distribution, etc.",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "b",
                        "key": "Name of publisher, distributor, etc.",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "c",
                        "key": "Date of publication, distribution, etc.",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "270",
                "name": "ADDRESS",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Address",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "b",
                        "key": "City",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "State or province",
                        "value": "",
                    },
                    {
                        "id": "d",
                        "key": "Country",
                        "value": "",
                    },
                    {
                        "id": "e",
                        "key": "Postal code",
                        "value": "",
                    },
                    {
                        "id": "f",
                        "key": "Terms preceding attention name",
                        "value": "",
                    },
                    {
                        "id": "g",
                        "key": "Attention name",
                        "value": "",
                    },
                    {
                        "id": "h",
                        "key": "Attention position",
                        "value": "",
                    },
                    {
                        "id": "i",
                        "key": "Type of address",
                        "value": "",
                    },
                    {
                        "id": "j",
                        "key": "Specialized telephone number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "k",
                        "key": "Telephone number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "l",
                        "key": "Fax number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "m",
                        "key": "Electronic mail address",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "n",
                        "key": "TDD or TTY number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "p",
                        "key": "Contact person",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "q",
                        "key": "Title of contact person",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "r",
                        "key": "Hours",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Public note",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "300",
                "name": "PHYSICAL DESCRIPTION",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Extent",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "b",
                        "key": "Other physical details",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Dimensions",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "e",
                        "key": "Accompanying material",
                        "value": "",
                    },
                    {
                        "id": "f",
                        "key": "Type of unit",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "g",
                        "key": "Size of unit",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "306",
                "name": "PLAYING TIME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Playing time",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "310",
                "name": "CURRENT PUBLICATION FREQUENCY",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Current publication frequency",
                        "value": "",
                    }
                ]
            },
            {
                "id": "362",
                "name": "DATES OF PUBLICATION AND/OR SEQUENTIAL DESIGNATION",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Dates of publication and/or sequential designation",
                        "value": "",
                    }
                ]
            },
            {
                "id": "365",
                "name": "TRADE PRICE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of price type code",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Price type code",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Price amount",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Currency code",
                        "value": "",
                    },
                    {
                        "id": "d",
                        "key": "Unit of pricing",
                        "value": "",
                    },
                    {
                        "id": "e",
                        "key": "Price note",
                        "value": "",
                    },
                    {
                        "id": "f",
                        "key": "Price effective from",
                        "value": "",
                    },
                    {
                        "id": "g",
                        "key": "Price effective until",
                        "value": "",
                    },
                    {
                        "id": "h",
                        "key": "Tax rate 1",
                        "value": "",
                    },
                    {
                        "id": "i",
                        "key": "Tax rate 2",
                        "value": "",
                    },
                    {
                        "id": "j",
                        "key": "ISO country code",
                        "value": "",
                    },
                    {
                        "id": "k",
                        "key": "MARC country code",
                        "value": "",
                    },
                    {
                        "id": "m",
                        "key": "Identification of pricing entity",
                        "value": "",
                    }
                ]
            },
            {
                "id": "366",
                "name": "TRADE AVAILABILITY INFORMATION",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of availability status code",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Publishers' compressed title identification",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Detailed date of publication",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Availability status code",
                        "value": "",
                    },
                    {
                        "id": "d",
                        "key": "Expected next availability date",
                        "value": "",
                    },
                    {
                        "id": "e",
                        "key": "Note",
                        "value": "",
                    },
                    {
                        "id": "f",
                        "key": "Publishers's discount category",
                        "value": "",
                    },
                    {
                        "id": "g",
                        "key": "Date made out of print",
                        "value": "",
                    },
                    {
                        "id": "j",
                        "key": "ISO country code",
                        "value": "",
                    },
                    {
                        "id": "k",
                        "key": "MARC country code",
                        "value": "",
                    },
                    {
                        "id": "m",
                        "key": "Identification of agency",
                        "value": "",
                    }
                ]
            },
            {
                "id": "490",
                "name": "SERIES STATEMENT",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Series statement",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "3",
                        "key": "Materials specified",
                        "value": "",
                    },
                    {
                        "id": "v",
                        "key": "Volume/sequential designation",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "International Standard Serial Number",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "500",
                "name": "GENERAL NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "General note",
                        "value": "",
                        "valueType": "textarea"
                    }
                ]
            },
            {
                "id": "500",
                "name": "GENERAL NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "General note",
                        "value": "",
                        "valueType": "textarea"
                    }
                ]
            },
            {
                "id": "500",
                "name": "GENERAL NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "General note",
                        "value": "",
                        "valueType": "textarea"
                    }
                ]
            },
            {
                "id": "501",
                "name": "WITH NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "With note",
                        "value": "",
                        "valueType": "textarea"
                    }
                ]
            },
            {
                "id": "504",
                "name": "BIBLIOGRAPHY, ETC. NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Bibliography, etc. note",
                        "value": "",
                        "valueType": "textarea"
                    }
                ]
            },
            {
                "id": "505",
                "name": "FORMATTED CONTENTS NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Formatted contents note",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "g",
                        "key": "Miscellaneous information",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "r",
                        "key": "Statement of responsibility",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "t",
                        "key": "Title",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "u",
                        "key": "Uniform Resource Identifier",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },
            {
                "id": "508",
                "name": "CREATION/PRODUCTION CREDITS NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Creation/production credits note",
                        "value": "",
                        "valueType": "textarea"
                    }
                ]
            },
            {
                "id": "511",
                "name": "PARTICIPANT OR PERFORMER NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Participant or performer note",
                        "value": "",
                        "valueType": "textarea"

                    }
                ]
            },
            {
                "id": "518",
                "name": "DATE/TIME AND PLACE OF AN EVENT NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Date/time and place of an event note",
                        "value": "",
                        "valueType": "textarea"
                    }
                ]
            },
            {
                "id": "520",
                "name": "SUMMARY, ETC.",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Summary, etc.",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "b",
                        "key": "Expansion of summary note",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "u",
                        "key": "Uniform Resource Identifier",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },
            {
                "id": "521",
                "name": "TARGET AUDIENCE NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Target audience note",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "b",
                        "key": "Source",
                        "value": "",
                        "valueType": "textarea"
                    }
                ]
            },
            {
                "id": "522",
                "name": "GEOGRAPHIC COVERAGE NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Geographic coverage note",
                        "value": "",
                        "valueType": "textarea"

                    }
                ]
            },
            {
                "id": "524",
                "name": "PREFERRED CITATION OF DESCRIBED MATERIALS NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Preferred citation of described materials note",
                        "value": "",
                        "valueType": "textarea"

                    }
                ]
            },
            {
                "id": "526",
                "name": "STUDY PROGRAM INFORMATION NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Program name",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "b",
                        "key": "Interest level",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "c",
                        "key": "Reading level",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "d",
                        "key": "Title point value",
                        "value": "",
                        "valueType": "textarea"
                    }
                ]
            },
            {
                "id": "530",
                "name": "ADDITIONAL PHYSICAL FORM AVAILABLE NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Additional physical form available note",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "b",
                        "key": "Availability source",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "c",
                        "key": "Availability conditions",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "d",
                        "key": "Order number",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "u",
                        "key": "Uniform Resource Identifier",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",

                    }
                ]
            },
            {
                "id": "533",
                "name": "REPRODUCTION NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Type of reproduction",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "b",
                        "key": "Place of reproduction",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "c",
                        "key": "Agency responsible for reproduction",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "d",
                        "key": "Date of reproduction",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "e",
                        "key": "Physical description of reproduction",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "f",
                        "key": "Series statement of reproduction",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "m",
                        "key": "Dates and/or sequential designation of issues reproduced",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "n",
                        "key": "Note about reproduction",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "y",
                        "key": "Data provenance",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },
            {
                "id": "538",
                "name": "SYSTEM DETAILS NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "System details note",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "i",
                        "key": "Display text",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "u",
                        "key": "Uniform Resource Identifier",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },
            {
                "id": "541",
                "name": "IMMEDIATE SOURCE OF ACQUISITION NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Source of acquisition",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "b",
                        "key": "Address",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "c",
                        "key": "Method of acquisition",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "d",
                        "key": "Date of acquisition",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "e",
                        "key": "Accession number",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "f",
                        "key": "Owner",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "h",
                        "key": "Purchase price",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "n",
                        "key": "Extent",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "o",
                        "key": "Type of unit",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },
            {
                "id": "546",
                "name": "LANGUAGE NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Language note",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "b",
                        "key": "Information code or alphabet",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",


                    }
                ]
            },
            {
                "id": "555",
                "name": "CUMULATIVE INDEX/FINDING AIDS NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Cumulative index/finding aids note",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "b",
                        "key": "Availability source",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "c",
                        "key": "Degree of control",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "d",
                        "key": "Bibliographic reference",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "u",
                        "key": "Uniform Resource Identifier",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },

            {
                "id": "556",
                "name": "INFORMATION ABOUT DOCUMENTATION NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Information about documentation note",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "z",
                        "key": "International Standard Book Number",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },
            {
                "id": "562",
                "name": "COPY AND VERSION IDENTIFICATION NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Identifying markings",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "b",
                        "key": "Copy identification",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "c",
                        "key": "Version identification",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "d",
                        "key": "Presentation format",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    },
                    {
                        "id": "e",
                        "key": "Number of copies",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },
            {
                "id": "563",
                "name": "BINDING INFORMATION",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Binding note",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "u",
                        "key": "Uniform Resource Identifier",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },
            {
                "id": "583",
                "name": "ACTION NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "x",
                        "key": "Nonpublic note",
                        "value": "",
                        "valueType": "textarea",
                        "copy": "true",
                        "delete": "true",

                    }
                ]
            },
            {
                "id": "585",
                "name": "EXHIBITIONS NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "3",
                        "key": "Materials specified",
                        "value": "",
                        "valueType": "textarea"

                    },
                    {
                        "id": "a",
                        "key": "Exhibitions note",
                        "value": "",
                        "valueType": "textarea"

                    }
                ]
            },
            {
                "id": "586",
                "name": "AWARDS NOTE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Awards note",
                        "value": "",
                        "valueType": "textarea"

                    }
                ]
            },
            {
                "id": "600",
                "name": "SUBJECT ADDED ENTRY--PERSONAL NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of heading or term",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Personal name",
                        "value": "",
                    },
                    {
                        "id": "d",
                        "key": "Dates associated with a name",
                        "value": "",
                    },
                    {
                        "id": "q",
                        "key": "Fuller form of name",
                        "value": "",
                    },
                    {
                        "id": "t",
                        "key": "Title of a work",
                        "value": "",
                    },
                    {
                        "id": "v",
                        "key": "Form subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "General subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Chronological subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Geographic subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "610",
                "name": "SUBJECT ADDED ENTRY--CORPORATE NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of heading or term",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Corporate name or jurisdiction name as entry element",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Subordinate unit",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "t",
                        "key": "Title of a work",
                        "value": "",
                    },
                    {
                        "id": "v",
                        "key": "Form subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "General subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Chronological subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Geographic subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "611",
                "name": "SUBJECT ADDED ENTRY--MEETING NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of heading or term",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Meeting name or jurisdiction name as entry element",
                        "value": "",
                        "disabled": "true"
                    },
                    {
                        "id": "c",
                        "key": "Location of meeting",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "e",
                        "key": "Subordinate unit",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "t",
                        "key": "Title of a work",
                        "value": "",
                    },
                    {
                        "id": "v",
                        "key": "Form subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "General subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Chronological subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Geographic subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "630",
                "name": "SUBJECT ADDED ENTRY--UNIFORM TITLE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Uniform title",
                        "value": "",
                    },
                    {
                        "id": "l",
                        "key": "Language of a work",
                        "value": "",
                    },
                    {
                        "id": "t",
                        "key": "Title of a work",
                        "value": "",
                    },
                    {
                        "id": "v",
                        "key": "Form subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "General subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Chronological subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Geographic subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "648",
                "name": "SUBJECT ADDED ENTRY--CHRONOLOGICAL TERM",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of heading or term",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Chronological term",
                        "value": "",
                    },
                    {
                        "id": "v",
                        "key": "Form subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "General subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Chronological subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Geographic subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "650",
                "name": "SUBJECT ADDED ENTRY--TOPICAL TERM",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of heading or term",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Topical term or geographic name entry element",
                        "value": "",
                    },
                    {
                        "id": "v",
                        "key": "Form subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "General subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Chronological subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Geographic subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "651",
                "name": "SUBJECT ADDED ENTRY--GEOGRAPHIC NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of heading or term",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Geographic name",
                        "value": "",
                    },
                    {
                        "id": "v",
                        "key": "Form subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "General subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Chronological subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Geographic subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "653",
                "name": "INDEX TERM--UNCONTROLLED",
                "copy": "true",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "a",
                        "key": "Uncontrolled term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "654",
                "name": "SUBJECT ADDED ENTRY--FACETED TOPICAL TERMS",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of heading or term",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Focus term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "b",
                        "key": "Non-focus term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "c",
                        "key": "Facet/hierarchy designation",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "v",
                        "key": "Form subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "General subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Chronological subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Geographic subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "655",
                "name": "INDEX TERM--GENRE/FORM",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of term",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Genre/form data or focus term",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Non-focus term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "c",
                        "key": "Facet/hierarchy designation",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "v",
                        "key": "Form subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "General subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Chronological subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Geographic subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "658",
                "name": "INDEX TERM--CURRICULUM OBJECTIVE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Main curriculum objective",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Subordinate curriculum objective",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "c",
                        "key": "Curriculum code",
                        "value": "",
                    }
                ]
            },
            {
                "id": "662",
                "name": "SUBJECT ADDED ENTRY--HIERARCHICAL PLACE NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "2",
                        "key": "Source of heading or term",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Country or larger entity",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "b",
                        "key": "First-order political jurisdiction",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Intermediate political jurisdiction",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "d",
                        "key": "City",
                        "value": "",
                    },
                    {
                        "id": "f",
                        "key": "City subsection",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "g",
                        "key": "Other nonjurisdictional geographic region and feature",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "h",
                        "key": "Extraterrestrial area",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "690",
                "name": "LOCAL SUBJECT ADDED ENTRY--TOPICAL TERM (OCLC, RLIN)",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of heading or term",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Topical term or geographic name as entry element",
                        "value": "",
                    },
                    {
                        "id": "v",
                        "key": "Form subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "x",
                        "key": "General subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Chronological subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Geographic subdivision",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "700",
                "name": "ADDED ENTRY--PERSONAL NAME",
                "indicator": {
                    0: '1',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Personal name",
                        "value": "",
                    },
                    {
                        "id": "e",
                        "key": "Relator term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "d",
                        "key": "Dates associated with a name",
                        "value": "",
                    },
                    {
                        "id": "q",
                        "key": "Fuller form of name",
                        "value": "",
                    }
                ]
            },
            {
                "id": "710",
                "name": "ADDED ENTRY--CORPORATE NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Corporate name or jurisdiction name as entry element",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Subordinate unit",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "e",
                        "key": "Relator term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "711",
                "name": "ADDED ENTRY--MEETING NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "delete": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Meeting name or jurisdiction name as entry element",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Location of meeting",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "e",
                        "key": "Subordinate unit",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "j",
                        "key": "Relator term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "720",
                "name": "ADDED ENTRY--UNCONTROLLED NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "4",
                        "key": "Relationship",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "a",
                        "key": "Name",
                        "value": "",
                    },
                    {
                        "id": "e",
                        "key": "Relator term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "730",
                "name": "ADDED ENTRY--UNIFORM TITLE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "9",
                        "key": "9 (RLIN)",
                        "value": "",
                        "disabled": "true"
                    },
                    {
                        "id": "a",
                        "key": "Uniform title",
                        "value": "",
                    },
                    {
                        "id": "l",
                        "key": "Language of a work",
                        "value": "",
                    },
                    {
                        "id": "m",
                        "key": "Medium of performance for music",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "r",
                        "key": "Key for music",
                        "value": "",
                    }
                ]
            },
            {
                "id": "740",
                "name": "ADDED ENTRY--UNCONTROLLED RELATED/ANALYTICAL TITLE",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Uncontrolled related/analytical title",
                        "value": "",
                    }
                ]
            },
            {
                "id": "760",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "name": "MAIN SERIES ENTRY",
                "children": [
                    {
                        "id": "b",
                        "key": "Edition",
                        "value": "",
                    }
                ]
            },
            {
                "id": "800",
                "name": "SERIES ADDED ENTRY--PERSONAL NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "4",
                        "key": "Relationship",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "9",
                        "key": "9 (RLIN)",
                        "value": "",
                        "disabled": "true"

                    },
                    {
                        "id": "a",
                        "key": "Personal name",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Numeration",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Titles and other words associated with a name",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "d",
                        "key": "Dates associated with a name",
                        "value": "",
                    },
                    {
                        "id": "e",
                        "key": "Relator term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "q",
                        "key": "Fuller form of name",
                        "value": "",
                    }
                ]
            },
            {
                "id": "810",
                "name": "SERIES ADDED ENTRY--CORPORATE NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "4",
                        "key": "Relationship",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "9",
                        "key": "9 (RLIN)",
                        "value": "",
                        "disabled": "true"

                    },
                    {
                        "id": "a",
                        "key": "Corporate name or jurisdiction name as entry element",
                        "value": "",
                    },
                    {
                        "id": "b",
                        "key": "Subordinate unit",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "c",
                        "key": "Location of meeting",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "d",
                        "key": "Date of meeting or treaty signing",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "e",
                        "key": "Relator term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "811",
                "name": "SERIES ADDED ENTRY--MEETING NAME",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "4",
                        "key": "Relationship",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "9",
                        "key": "9 (RLIN)",
                        "value": "",
                        "disabled": "true"

                    },
                    {
                        "id": "a",
                        "key": "Meeting name or jurisdiction name as entry element",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Location of meeting",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "e",
                        "key": "Subordinate unit",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "j",
                        "key": "Relator term",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "830",
                "name": "SERIES ADDED ENTRY--UNIFORM TITLE",
                "indicator": {
                    0: '',
                    1: '0'
                },
                "copy": "true",
                "children": [
                    {
                        "id": "a",
                        "key": "Uniform title",
                        "value": "",
                    },
                    {
                        "id": "9",
                        "key": "9 (RLIN)",
                        "value": "",
                        "disabled": "true"

                    },
                    {
                        "id": "l",
                        "key": "Language of a work",
                        "value": "",
                    },
                    {
                        "id": "r",
                        "key": "Key for music",
                        "value": "",
                    },
                    {
                        "id": "s",
                        "key": "Version",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "856",
                "name": "ELECTRONIC LOCATION AND ACCESS",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "3",
                        "key": "Materials specified",
                        "value": "",
                    },
                    {
                        "id": "u",
                        "key": "Uniform Resource Identifier",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "y",
                        "key": "Link text",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "z",
                        "key": "Public note",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    }
                ]
            },
            {
                "id": "887",
                "name": "NON-MARC INFORMATION FIELD",
                "indicator": {
                    0: '',
                    1: ''
                },
                "copy": "true",
                "children": [
                    {
                        "id": "2",
                        "key": "Source of data",
                        "value": "",
                    },
                    {
                        "id": "a",
                        "key": "Content of non-MARC field",
                        "value": "",
                    }
                ]
            },
            {
                "id": "942",
                "name": "ADDED ENTRY ELEMENTS (KOHA)",
                "indicator": {
                    0: '',
                    1: ''
                },
                "children": [
                    {
                        "id": "2",
                        "key": "Source of classification or shelving scheme",
                        "value": "",
                    },
                    {
                        "id": "c",
                        "key": "Koha item type",
                        "value": "",
                        "require": "true",
                    },
                    {
                        "id": "e",
                        "key": "Edition",
                        "value": "",
                    },
                    {
                        "id": "h",
                        "key": "Classification part",
                        "value": "",
                        "copy": "true",
                        "delete": "true",
                    },
                    {
                        "id": "i",
                        "key": "Item part",
                        "value": "",
                    },
                    {
                        "id": "k",
                        "key": "Call number prefix",
                        "value": "",
                    },
                    {
                        "id": "m",
                        "key": "Call number suffix",
                        "value": "",
                    },
                    {
                        "id": "n",
                        "key": "Suppress in OPAC",
                        "value": "",
                    }
                ]
            }
        ]

    )
    const [ClassificationData, setClassificationData] = useState([])
    const isInternalUpdate = useRef(false)

    const Classification = (datas) => {
        // id 分類器
        let NewClassificationData = {
            0: [],
            1: [],
            2: [],
            3: [],
            4: [],
            5: [],
            6: [],
            7: [],
            8: [],
            9: []
        }
        datas?.forEach((data) => {
            NewClassificationData[parseInt(data["id"][0])].push(data)
        })
        return NewClassificationData
    }


    // setMarcJson2Marc 函數修改
    const setMarcJson2Marc = useCallback((values) => {
        let bib = values?.data?.find(_ => true);

        if (!bib?.metadata) return;

        const transformedBib = [
            {
                "tag": "000",
                subfield: [{
                    code: "00",
                    "text": bib?.metadata?.leader
                }]
            },
            ...bib?.metadata?.controlfield?.map(item => ({
                ...item,
                subfield: [{
                    code: "00",
                    text: item?.text
                }]
            })),
            ...bib?.metadata?.datafield,
        ];

        const classifiedData = Classification(
            datas?.map(item => {
                const bib_ = transformedBib?.find(findItem => findItem?.tag === item?.id);
                let indicator = undefined;

                if (bib_?.ind1 && bib_?.ind2) {
                    indicator = {
                        0: bib_?.ind1,
                        1: bib_?.ind2
                    };
                }

                if (bib_) {
                    return {
                        ...item,
                        indicator: indicator,
                        children: item?.children?.map(mapItem => {
                            const bib_subfield = bib_?.subfield?.find(findItem =>
                                findItem?.code === mapItem?.id
                            );
                            return {
                                ...mapItem,
                                value: bib_subfield?.text || mapItem?.value
                            };
                        })
                    };
                }
                return item;
            })
        );

        setClassificationData(classifiedData);
    }, [Classification]);
    // const setMarcJson2Marc = (values) => {

    //     let bib = values?.data?.find(_ => true)

    //     bib = [
    //         {
    //             "tag": "000",
    //             subfield: [
    //                 {
    //                     code: "00",
    //                     "text": bib?.metadata?.leader
    //                 }
    //             ]
    //         },
    //         ...bib?.metadata?.controlfield?.map(item => {
    //             return {
    //                 ...item,
    //                 subfield: [
    //                     {
    //                         code: "00",
    //                         text: item?.text
    //                     }
    //                 ]
    //             }
    //         }),
    //         ...bib?.metadata?.datafield,
    //     ]
    //     setClassificationData(Classification(
    //         datas?.map(item => {
    //             const bib_ = bib?.find(findItem => findItem?.tag === item?.id)
    //             let indicator = undefined

    //             if (bib_?.ind1 && bib_?.ind2) {
    //                 indicator = {
    //                     0: bib_?.ind1,
    //                     1: bib_?.ind2
    //                 }
    //             }
    //             if (bib_) {
    //                 return {
    //                     ...item,
    //                     indicator: indicator,
    //                     children: item?.children?.map(mapItem => {
    //                         const bib_subfield = bib_?.subfield?.find(findItem => findItem?.code === mapItem?.id)
    //                          if (bib_subfield) {
    //                             return {
    //                                 ...mapItem,
    //                                 value: bib_subfield?.text
    //                             }
    //                         } else {
    //                             return {
    //                                 ...mapItem
    //                             }
    //                         }

    //                     })
    //                 }
    //             }
    //             else {
    //                 return {
    //                     ...item,
    //                 }
    //             }
    //         })
    //     ))
    // }


    // const {
    //     getBibData,
    //     postBibData,
    //     patchBibData,
    // } = useBib({
    //     onFinish: ({ axiosMode, status, values, message }) => {
    //         if (axiosMode === "get") {
    //             if (status === "success") {
    //                 /* convert marc21 to react */
    //                 setMarcJson2Marc(values)
    //                 // setMarcJson2Marc 的資料型態  setMarcJson2Marc({ data: [{ metadata: marcjson }] })
    //                 /* convert marc21 to react */
    //             }
    //         } else if (axiosMode === "post") {
    //             if (status === "success") {
    //                 toast.success('新增成功');
    //             } else if (status === "error") {
    //                 toast.error('新增失敗');
    //             }
    //         }
    //     },
    //     onBefore: () => { }
    // })

    // useEffect(() => {
    //     if (bib_biblionumber) {
    //         getBibData({
    //             biblionumber: bib_biblionumber,
    //             marcdata: "json"
    //         })
    //     }
    //     setClassificationData(Classification(datas))
    //     if (marcjson) {
    //         setMarcJson2Marc({ data: [{ metadata: marcjson }] })
    //     }
    // }, [])
    // 將數據轉換邏輯抽出為 useMemo
    const convertedData = useMemo(() => {
        const hasData = Object.values(ClassificationData).some(arr => arr.length > 0);
        if (!hasData) return null;

        const record = Object.values(ClassificationData)
            .reduce((current, item) => [...current, ...item], []);

        const leader = record?.find(findItem => findItem?.id === "000")?.children?.find(_ => true)?.value;
        const controlfield = record?.
            filter(filterItem => ['001', '003', '005', '006', '007', '008'].includes(filterItem?.id))
            .map(mapItem => ({
                tag: mapItem?.id,
                text: mapItem?.children?.find(_ => true)?.value,
            }));
        const datafield = record?.
            filter(filterItem => !['000', '001', '003', '005', '006', '007', '008'].includes(filterItem?.id))
            .map(mapItem => ({
                tag: mapItem?.id,
                ind1: mapItem?.indicator?.[0] || ' ',
                ind2: mapItem?.indicator?.[1] || ' ',
                subfield: mapItem?.children?.map(item => ({
                    code: item?.id,
                    text: item?.value,
                }))
            }));

        return {
            leader,
            controlfield,
            datafield
        };
    }, [ClassificationData]);
    // 處理 ClassificationData 變化
    useEffect(() => {

        if (!convertedData) return;

        const metadata = {
            leader: convertedData.leader,
            controlfield: convertedData.controlfield,
            datafield: convertedData.datafield,
        };

        const changeEvent = {
            target: {
                name,
                value: metadata
            }
        };

        onChange(changeEvent);
        onValueChange(changeEvent);
    }, [convertedData, name, isInternalUpdate.current]);
    // 處理外部 value 變化
    useEffect(() => {
        if (!isInternalUpdate.current) {
            setClassificationData(Classification(datas))

        }
        if (!value || isInternalUpdate.current) return;
        isInternalUpdate.current = true
        setMarcJson2Marc({ data: [{ metadata: value }] });

        // 重置標誌
        // setTimeout(() => {
        //     isInternalUpdate.current = false
        // }, 0);
        // return ()=>{
        //     isInternalUpdate.current = false
        // }
    }, [defaultValue]);
    return (
        <Row>
            <Col span={24}>
                <Tabs
                    defaultActiveKey={0}
                    items={Object.entries(ClassificationData).map((value, key) => (
                        {
                            key: key,
                            tab: value[0],
                            content: <>
                                <Section ClassificationData={ClassificationData} setClassificationData={setClassificationData} SectionNumber={value[0]} SectionData={value[1]} />
                            </>
                        }
                    ))}
                >
                </Tabs>
            </Col>
        </Row>

    )
}
const Section = ({
    SectionNumber = 0,
    SectionData = [],
    ClassificationData = [],
    setClassificationData = () => { }
}) => {
    const scrollToTarget = (id) => {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    };
    const copySection = (key) => {
        setClassificationData(pre => {
            const updatedData = JSON.parse(JSON.stringify(pre));
            const section = updatedData[SectionNumber];
            let searchData = section[key];
            let newSearchData = JSON.parse(JSON.stringify(searchData));
            section.splice(key + 1, 0, newSearchData);
            updatedData[SectionNumber] = section;
            return updatedData;
        });
    };

    const deleteSection = (key) => {
        let count = 0
        let searchData = SectionData.find((data, index) => {
            if (index === key) {
                return data
            }
        })
        SectionData.map((data) => {
            if (data?.id === searchData.id) {
                count += 1
            }
        })

        if (count > 1) {
            SectionData.splice(key, 1);
            setClassificationData(pre => {
                let data = { ...pre };
                data[SectionNumber] = [...SectionData];
                return data;
            });
        } else {
            alert('最少要留一個');
        }
    };


    const copySectionChildren = (key, key2) => {
        setClassificationData(pre => {
            const updatedData = JSON.parse(JSON.stringify(pre));
            let searchData = updatedData[SectionNumber][key];
            let searchChildrenData = { ...searchData.children[key2] };
            searchData.children.splice(key2 + 1, 0, searchChildrenData);
            updatedData[SectionNumber][key] = searchData;
            return updatedData;
        });
    };

    const deleteSectionChildren = (key, key2) => {
        let searchData = SectionData.find((data, index) => { if (index === key) { return data } })
        let searchChildrenData = searchData?.children.find((data, index) => { if (index === key2) return data })
        let count = 0
        searchData?.children.map((data) => {
            if (data?.id === searchChildrenData.id) {
                count += 1
            }
        })
        // 至少要留一個
        if (count > 1) {
            setClassificationData(pre => {
                const updatedData = JSON.parse(JSON.stringify(pre));
                let searchData = updatedData[SectionNumber][key];
                searchData.children.splice(key2, 1);
                updatedData[SectionNumber][key] = searchData;
                return updatedData;
            });
        } else {
            alert('最少要留一個');
        }
    };

    const updateChildValue = (key, key2, col, value) => {
        setClassificationData((prevData) => {
            const updatedData = { ...prevData };
            const section = updatedData[SectionNumber];
            if (section) {
                const item = section[key];
                if (item) {
                    const child = item.children[key2];
                    if (child) {
                        const newChild = { ...child, [col]: value };
                        item.children[key2] = newChild;
                    }
                }
            }
            return updatedData;
        });
    };

    const updateValue = (key, col, value) => {
        setClassificationData((prevData) => {
            let updatedData = JSON.parse(JSON.stringify(prevData)); // deep copy
            if (col === 'indicator0') {
                updatedData[SectionNumber][key]['indicator'][0] = value
            }
            if (col === 'indicator1') {
                updatedData[SectionNumber][key]['indicator'][1] = value
            }
            updatedData[SectionNumber][key][col] = value
            return updatedData;
        });
    }





    return (
        <MainContainer>
            <Toaster richColors position="top-center" />
            <Col span={24}>
                <Row gutter={[16, 16]}>
                    {SectionData?.map((Section, key) => {
                        return (
                            <>
                                <Col onClick={() => scrollToTarget(Section['id'])} className='text-blue-500 cursor-pointer	' >
                                    {Section['id']}
                                </Col>
                                <Col >
                                    |
                                </Col>
                            </>
                        )
                    })}
                </Row>
            </Col>
            <SubTitle className='mt-3' >Section {SectionNumber}</SubTitle>

            {SectionData?.map((Section, key) => {
                // console.log(key,Section)
                return (
                    <ContextBox>
                        <Col span={24}>
                            <Row align={'middle'} gutter={[16, 16]}>
                                <Col id={Section['id']} className="mr-2 font-bold	" >{Section['id']}. </Col>
                                {Section?.indicator && (
                                    <>
                                        <Col >
                                            <input
                                                onInput={(e) => {
                                                    updateValue(key, "indicator0", e?.target?.value)
                                                }}
                                                type="text" value={Section?.indicator[0]} maxlength="1" className=" w-6 h-8 mr-1  text-center border-2 border-gray-300 rounded-lg focus:outline-none focus:border-blue-500" />
                                            <input
                                                onInput={(e) => {
                                                    updateValue(key, "indicator1", e?.target?.value)
                                                }}
                                                type="text" value={Section?.indicator[1]} maxlength="1" className="w-6 h-8  text-center border-2 border-gray-300 rounded-lg focus:outline-none focus:border-blue-500" />
                                        </Col>
                                    </>
                                )}

                                <Col>- {Section['name']}</Col>
                                {Boolean(Section?.copy) === true && (
                                    <Col onClick={() => { copySection(key) }} className=" cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard2-plus" viewBox="0 0 16 16">
                                            <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z" />
                                            <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z" />
                                            <path d="M8.5 6.5a.5.5 0 0 0-1 0V8H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V9H10a.5.5 0 0 0 0-1H8.5z" />
                                        </svg>
                                    </Col>
                                )}
                                <Col onClick={() => { deleteSection(key) }} className=" cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                    </svg>
                                </Col>
                            </Row>


                        </Col>
                        <Col span={24} className='pl-20' >                            {
                            Section['children'].map((children, key2) => {
                                return (
                                    <Row wrap={false} gutter={[16, 16]} align={'top'} className='my-2'>
                                        <Col span={2}>
                                            <input
                                                style={{ 'backgroundColor': "#fcfbf6" }
                                                } className="w-full text-center"
                                                value={children['id']}
                                                onInput={(e) => {
                                                    updateChildValue(key, key2, "id", e?.target?.value)
                                                }}
                                            />
                                        </Col>
                                        <Col span={6} className='text-right' >
                                            <span>{children['key']}.</span>
                                        </Col>
                                        <Col span={11}>
                                            {children["valueType"] === 'textarea' ? (
                                                <>
                                                    <Textarea
                                                        disabled={Boolean(children["disabled"])}
                                                        value={children['value']}
                                                        onInput={(e) => {
                                                            updateChildValue(key, key2, "value", e?.target?.value)
                                                        }}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <Input
                                                        disabled={Boolean(children["disabled"])}
                                                        value={children['value']}
                                                        onInput={(e) => {
                                                            updateChildValue(key, key2, "value", e?.target?.value)
                                                        }}
                                                    />
                                                </>
                                            )}



                                        </Col>
                                        {Boolean(children?.copy) === true && (
                                            <Col span={1} onClick={() => { copySectionChildren(key, key2) }} className=" cursor-pointer">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard2-plus" viewBox="0 0 16 16">
                                                    <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z" />
                                                    <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z" />
                                                    <path d="M8.5 6.5a.5.5 0 0 0-1 0V8H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V9H10a.5.5 0 0 0 0-1H8.5z" />
                                                </svg>
                                            </Col>
                                        )}
                                        {Boolean(children?.delete) === true && (
                                            <Col span={1} onClick={() => { deleteSectionChildren(key, key2) }} className=" cursor-pointer">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                                                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                                </svg>
                                            </Col>

                                        )}
                                        {Boolean(children?.require) === true && (
                                            <>
                                                <Col span={2} className='text-red-600 italic'>
                                                    Required
                                                </Col>
                                            </>
                                        )}


                                    </Row>
                                )
                            })}
                        </Col>
                    </ContextBox>
                )
            })}
        </MainContainer>
    )

}
// const Section0 = () => {

//     return (
//         <MainContainer>
//             <SubTitle>Section 0</SubTitle>
//             <ContextBox>
//                 <span>000</span>
//                 <span>LEADER</span>
//                 <FlexBox>
//                     <span>fixed length control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox>
//             <ContextBox>
//                 <span>003</span>
//                 <span>CONTROL NUMBER IDENTIFIER</span>

//                 <FlexBox>
//                     <span>control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox>
//             <ContextBox>
//                 <span>005</span>
//                 <span> DATE AND TIME OF LATEST TRANSACTION</span>

//                 <FlexBox>
//                     <span>control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox>
//             <ContextBox>
//                 <span>008</span>
//                 <span> FIXED-LENGTH DATA ELEMENTS--GENERAL INFORMATION</span>

//                 <FlexBox>
//                     <span>fixed length control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox>
//             <ContextBox>
//                 <span>040</span>
//                 <span> CATALOGING SOURCE</span>

//                 <FlexBox>
//                     <span>Transcribing agency</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox>
//         </MainContainer>
//     )

// }
// const Section1 = () => {

//     return (
//         <MainContainer>
//             <SubTitle>Section 1</SubTitle>
//             {/* <ContextBox>
//                 <span>000</span>
//                 <span>LEADER</span>
//                 <FlexBox>
//                     <span>fixed length control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox> */}
//         </MainContainer>
//     )
// }
// const Section2 = () => {

//     return (
//         <MainContainer>
//             <SubTitle>Section 2</SubTitle>
//             <ContextBox>
//                 <span>245</span>
//                 <span> TITLE STATEMENT </span>
//                 <FlexBox>
//                     <span>Title</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox>
//         </MainContainer>
//     )
// }
// const Section3 = () => {

//     return (
//         <MainContainer>
//             <SubTitle>Section 3</SubTitle>
//             {/* <ContextBox>
//                 <span>000</span>
//                 <span>LEADER</span>
//                 <FlexBox>
//                     <span>fixed length control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox> */}
//         </MainContainer>
//     )
// }
// const Section4 = () => {

//     return (
//         <MainContainer>
//             <SubTitle>Section 4</SubTitle>
//             {/* <ContextBox>
//                 <span>000</span>
//                 <span>LEADER</span>
//                 <FlexBox>
//                     <span>fixed length control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox> */}
//         </MainContainer>
//     )
// }
// const Section5 = () => {

//     return (
//         <MainContainer>
//             <SubTitle>Section 5</SubTitle>
//             {/* <ContextBox>
//                 <span>000</span>
//                 <span>LEADER</span>
//                 <FlexBox>
//                     <span>fixed length control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox> */}
//         </MainContainer>
//     )
// }
// const Section6 = () => {

//     return (
//         <MainContainer>
//             <SubTitle>Section 6</SubTitle>
//             {/* <ContextBox>
//                 <span>000</span>
//                 <span>LEADER</span>
//                 <FlexBox>
//                     <span>fixed length control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox> */}
//         </MainContainer>
//     )
// }
// const Section7 = () => {

//     return (
//         <MainContainer>
//             <SubTitle>Section 7</SubTitle>
//             {/* <ContextBox>
//                 <span>000</span>
//                 <span>LEADER</span>
//                 <FlexBox>
//                     <span>fixed length control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox> */}
//         </MainContainer>
//     )
// }
// const Section8 = () => {

//     return (
//         <MainContainer>
//             <SubTitle>Section 8</SubTitle>
//             {/* <ContextBox>
//                 <span>000</span>
//                 <span>LEADER</span>
//                 <FlexBox>
//                     <span>fixed length control field</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox> */}
//         </MainContainer>
//     )
// }
// const Section9 = () => {

//     return (
//         <MainContainer>
//             <SubTitle>Section 9</SubTitle>
//             <ContextBox>
//                 <span>942</span>
//                 <span> ADDED ENTRY ELEMENTS (KOHA)</span>
//                 <FlexBox>
//                     <span>Source of classification or shelving scheme</span>
//                     <Input />
//                 </FlexBox>
//             </ContextBox>
//         </MainContainer>
//     )
// }

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const ContextBox = styled.div`
display: flex;
flex-direction: row;
flex-wrap: wrap;
align-items: center;
justify-content: flex-start;
gap: 1em;
width: -webkit-fill-available;
border-bottom: 2px solid #bbbbbb;
padding: 1em 0;
`

const FlexBox = styled.div`
padding-left : 30px;
width: -webkit-fill-available;
display: flex;
align-items: center;
flex-wrap: nowrap;
flex-direction: row;
text-wrap: nowrap;
gap: 1em;
`

export default MARCFormItems